import { useParams, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import api from '../api/client';
import { ExpertProfileTab } from '../profile/ExpertProfileTab';

interface UserInfo {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  jobTitle?: string | null;
  department?: string | null;
  avatar?: string | null;
}

export function AdminProfileDetailPage() {
  const { userId } = useParams<{ userId: string }>();
  const navigate = useNavigate();
  const [user, setUser] = useState<UserInfo | null>(null);

  useEffect(() => {
    if (!userId) return;
    api
      .get<UserInfo[]>('/expert-profile/admin/users')
      .then(({ data }) => {
        const found = data.find((u) => u.id === userId);
        if (found) setUser(found);
      })
      .catch(() => {
        // user info is optional — profile still renders
      });
  }, [userId]);

  if (!userId) return null;

  const apiBase = `/expert-profile/admin/users/${userId}`;

  return (
    <div style={{ padding: '1.5rem' }}>
      <button
        type="button"
        onClick={() => navigate('/admin/profile-access')}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: '#2563eb',
          fontSize: '0.875rem',
          padding: '0 0 1rem 0',
          display: 'flex',
          alignItems: 'center',
          gap: '0.25rem',
        }}
      >
        ← Zurück zu Profilzugriff
      </button>

      {user && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
          {user.avatar ? (
            <img
              src={user.avatar}
              alt={`${user.firstName} ${user.lastName}`}
              style={{ width: 56, height: 56, borderRadius: '50%', objectFit: 'cover' }}
            />
          ) : (
            <div
              style={{
                width: 56,
                height: 56,
                borderRadius: '50%',
                background: '#e5e7eb',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '1.25rem',
                fontWeight: 600,
                color: '#6b7280',
                flexShrink: 0,
              }}
            >
              {user.firstName[0]}{user.lastName[0]}
            </div>
          )}
          <div>
            <h2 style={{ margin: 0, fontSize: '1.25rem', fontWeight: 700 }}>
              {user.firstName} {user.lastName}
            </h2>
            <div style={{ color: '#6b7280', fontSize: '0.875rem' }}>
              {[user.jobTitle, user.department].filter(Boolean).join(' · ')}
            </div>
            <div style={{ color: '#9ca3af', fontSize: '0.75rem' }}>{user.email}</div>
          </div>
        </div>
      )}

      <ExpertProfileTab apiBase={apiBase} />
    </div>
  );
}
